<button class="d-block mx-auto plain">
  <ng-content></ng-content>
  <i class="fa fa-arrow-circle-right"></i>
</button> 